module.exports = __webpack_public_path__ + "img/pathfinder.771532a9.png";